module.exports = __webpack_public_path__ + "static/img/biaozun.ec4be8ae.png";